import styled, { css } from "styled-components";

export const Container = styled.div<{ $fillSpace?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 16 / 9;
  margin-bottom: 1.5rem;

  ${({ $fillSpace }) => $fillSpace && css`
    height: 100%;
    aspect-ratio: unset;
    margin-bottom: unset
  `};

  > iframe {
    width: 100%;
    height: 100%;
  }
`;
